export const FETCH_DATA = "FETCH_DATA";
export const SAVE_DATA = "SAVE_DATA";